export class MarkBlockUnblock {
    userIds: number[] = [];
    isBlocked: boolean;
}